import styled from '../../../theme/styled-with-theme';
import { pxToRem } from '../../../styles/utils';
import { mediaQueries } from '../../../styles/media-queries';
import { Input, Button as StyledButton, ErrorMessage } from '../styles';
import { Flexbox } from '../../Flexbox';

export const GetStartedWrapper = styled(Flexbox)`
  position: relative;
  height: 100%;
  width: fit-content;
  align-self: center;
  margin-bottom: ${({ theme }) => theme.spacing.m};
`;

export const GetStartedInput = styled(Input, {
  shouldForwardProp: (prop) => prop !== 'isScrolled'
})<{ isScrolled?: boolean; borderColor?: string }>`
  width: 100%;
  flex: 1 1 auto;
  align-self: center;
  padding: ${({ theme, isScrolled }) =>
    isScrolled ? `${theme.spacing.sm} ${theme.spacing.m}` : theme.spacing.ml};
  padding-right: ${({ theme, isScrolled }) =>
    isScrolled ? theme.spacing.xl : theme.spacing['2xl']};
  border: ${({ theme }) => `${pxToRem(1)} solid ${theme.cfColor.green}`};
  overflow: hidden;
  opacity: 1;

  transition: flex-grow 0.3s cubic-bezier(0, 0.7, 0.3, 1.01);

  ${({ borderColor }) => `
    border: ${pxToRem(1)} solid ${borderColor};
  `}

  ${({ isScrolled }) => `
    height: ${pxToRem(56)};
    width: ${isScrolled ? pxToRem(224) : pxToRem(286)};
    border-radius: ${pxToRem(8)};
    
    font-size: ${pxToRem(14)};

    ::placeholder {
      font-size: ${pxToRem(14)};
    }
  `}

  ${mediaQueries[0]} {
    ${({ isScrolled, theme }) => `
      width: ${isScrolled ? pxToRem(174) : pxToRem(252)};
      font-size: ${pxToRem(14)};

      padding: ${
        isScrolled ? `${theme.spacing.sm} ${theme.spacing.s}` : theme.spacing.m
      };
      padding-right: ${isScrolled ? theme.spacing.l : theme.spacing.xl};

      ::placeholder {
        font-size: ${pxToRem(14)};
      }
    `}
  }

  ${mediaQueries.desktop} {
    height: ${pxToRem(56)};
    width: ${pxToRem(286)};
    font-size: ${pxToRem(14)};
    border-radius: ${({ theme }) => theme.borderRadius.input_mobile_nav};
    ::placeholder {
      font-size: ${({ theme }) => theme.fontSize.m};
    }
  }
`;

export const GetStartedButton = styled(StyledButton, {
  shouldForwardProp: (prop) => prop !== 'isScrolled'
})<{ isScrolled?: boolean }>`
  z-index: 1;
  flex: 1 1 auto;
  align-self: center;
  white-space: nowrap;
  overflow: hidden;
  min-width: fit-content;
  -webkit-tap-highlight-color: transparent;

  transition: all 0.3s cubic-bezier(0, 0.7, 0.3, 1.01);
  will-change: width, flex-grow;

  ${({ isScrolled, theme }) => `
    font-size: ${isScrolled ? theme.fontSize.s : theme.fontSize.sm};
    height: ${isScrolled ? pxToRem(40) : pxToRem(56)};
    min-height: ${pxToRem(32)};
    width: ${isScrolled ? pxToRem(104) : pxToRem(286)};
    border-radius: ${theme.borderRadius.input_mobile_nav};
  `}

  ${mediaQueries.desktop} {
    height: ${pxToRem(56)};
    width: ${({ isScrolled }) => (isScrolled ? pxToRem(104) : pxToRem(286))};
    font-size: ${({ theme }) => theme.fontSize.sm};
    border-radius: ${pxToRem(8)};
  }
`;

export const GetStartedIconBtn = styled(GetStartedButton)<{
  isLoaderStickyButton?: boolean;
}>`
  padding: ${({ theme }) => `0 ${theme.spacing.s}`};
  margin: auto 2%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 0;

  &:hover,
  :focus,
  :active {
    color: rgba(0, 0, 0, 0);
  }

  ${({ isScrolled, theme, isLoaderStickyButton }) => `
    height: ${pxToRem(40)};
    width: ${
      isLoaderStickyButton
        ? pxToRem(83)
        : isScrolled
          ? pxToRem(32)
          : pxToRem(48)
    };
    border-radius: ${
      isScrolled ? theme.borderRadius.input_button : theme.borderRadius.button
    };
  `}

  ${mediaQueries[0]} {
    margin: ${({ theme, isScrolled }) =>
      isScrolled ? `auto 2.5%` : `auto ${theme.spacing.s}`};
  }

  ${mediaQueries.mobile} {
    margin: ${({ theme, isScrolled }) =>
      isScrolled ? `auto 2%` : `auto ${theme.spacing.s}`};
  }

  ${mediaQueries.desktop} {
    border-radius: ${({ theme }) => theme.borderRadius.button};
    height: ${pxToRem(40)};
    max-height: ${pxToRem(40)};
    width: ${pxToRem(48)};
    min-width: ${pxToRem(48)};
    margin: ${({ theme }) => `auto ${theme.spacing.s}`};
  }
`;

export const Error = styled(ErrorMessage)<{ isScrolled?: boolean }>`
  ${({ position, isScrolled = false }) =>
    position === 'top'
      ? `
      bottom: ${isScrolled ? pxToRem(30) : pxToRem(55)};
    `
      : `
      top: ${isScrolled ? pxToRem(30) : pxToRem(55)};
    `};

  ${mediaQueries.tablet} {
    ${({ position, isScrolled }) =>
      position === 'top'
        ? `
      bottom: ${isScrolled ? pxToRem(30) : pxToRem(55)};
    `
        : `
      top: ${isScrolled ? pxToRem(30) : pxToRem(55)};
    `};
  }

  ${mediaQueries.max} {
    ${({ position, isScrolled }) =>
      position === 'top'
        ? `

      bottom: ${isScrolled ? pxToRem(30) : pxToRem(55)};
    `
        : `
      top: ${isScrolled ? pxToRem(30) : pxToRem(55)};
    `};
  }
`;
